import { request } from "./client";

function normalizeAnnouncement(a) {
  return {
    id: a?.id ?? "",
    title: a?.title ?? "(Untitled)",
    body: a?.body ?? a?.content ?? "",
    status: a?.status ?? null,
    publishedAt: a?.publishedAt ?? null,
    isPinned: a?.isPinned === true,
    pinnedAt: a?.pinnedAt ?? null,
    createdAt: a?.createdAt ?? null,
    updatedAt: a?.updatedAt ?? null,
  };
}

// The API returns pinned items first (most recently pinned on top), then the
// rest newest-first. Keep that order. The endpoint also returns draft /
// scheduled / unpublished items, so the user-facing board must filter to
// published only.
export const getAnnouncements = async () => {
  const res = await request("/announcements");
  const list = Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
  return list
    .map(normalizeAnnouncement)
    .filter((a) => a.status === "published");
};
